import React from 'react';

const ImageCellRenderer = (props) => {
    const { value } = props;
    return value !== '' ? <img src={encodeURI(value)} alt="desktopimage" width="50px" height="50px" /> : null;
};

export default ImageCellRenderer;
